export { ButtonCheckboxDirective } from './button-checkbox.directive';
export { ButtonRadioGroupDirective } from './button-radio-group.directive';
export { ButtonRadioDirective } from './button-radio.directive';
export { ButtonsModule } from './buttons.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/buttons/index.js
// module id = ../../../../ngx-bootstrap/buttons/index.js
// module chunks = 4